// Punkt wejscia bundlera Vite: laduje zaleznosci zewnetrzne i bootstrapuje aplikacje.
import Dexie from 'dexie';
import * as ScanditCore from '@scandit/web-datacapture-core';
import * as ScanditBarcode from '@scandit/web-datacapture-barcode';
import '../styles/bootstrap-theme.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';
import '../styles/app.css';
import { installGlobalErrorAlert } from './services/globalErrorAlert';

window.Dexie = Dexie;
window.ScanditCore = ScanditCore;
window.ScanditBarcode = ScanditBarcode;

installGlobalErrorAlert();

await import('./app');
